<template>
    <div id="fd" class="index-fd pr">
        <div class="fd-copy">
            <div class="wp">
                <span style="color:#CCCCCC;">
                Copyright &copy; 2019 LNNEAR 灵能（南京）智能科技有限公司 版权所有
                </span>
                <span style="margin-left: 8px;">
                    备案号: <a href="https://beian.miit.gov.cn" target="_blank" style="color:#CCCCCC;">
                    <template v-if="isCnDomain">苏ICP备19026084号-2</template>
                    <template v-else>苏ICP备19026084号-1</template></a>
                </span>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Copyright",
    data() {
        return {
            isCnDomain: false,
        }
    },
    mounted() {
        let host = window.location.host.toLowerCase();
        if (host.endsWith(".cn")) {
            this.isCnDomain = true;
        }
    }
}
</script>

<style scoped>

</style>
